import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedPipesModule } from '../../shared-pipes';
import { BadgeModule } from '../badge';
import { RoutingTabNavBarComponent } from './routing-tab-nav-bar.component';

@NgModule({
  imports: [CommonModule, RouterModule, SharedPipesModule, BadgeModule],
  declarations: [RoutingTabNavBarComponent],
  exports: [RoutingTabNavBarComponent],
})
export class RoutingTabNavBarModule {}
